import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const legalContent = {
  gizlilik: {
    title: 'Gizlilik Politikası',
    content: `
# Gizlilik Politikası

Son güncelleme: Ocak 2026

KOSAD - Kocaeli Sürdürülebilir Arıcılık ve Dayanışma Derneği ("biz", "bize" veya "KOSAD") olarak gizliliğinizi korumaya önem veriyoruz.

## 1. Topladığımız Bilgiler

Web sitemizi ziyaret ettiğinizde ve hizmetlerimizi kullandığınızda aşağıdaki bilgileri toplayabiliriz:

- **Kişisel Bilgiler**: Ad, soyad, e-posta adresi, telefon numarası, adres
- **Üyelik Bilgileri**: Üyelik başvurularında sağlanan bilgiler
- **Sipariş Bilgileri**: Market alışverişlerinde teslimat ve fatura bilgileri
- **İletişim Bilgileri**: Formlar aracılığıyla gönderdiğiniz mesajlar

## 2. Bilgilerin Kullanımı

Topladığımız bilgileri şu amaçlarla kullanırız:

- Hizmetlerimizi sunmak ve geliştirmek
- Siparişlerinizi işlemek ve teslim etmek
- Üyelik işlemlerini yönetmek
- İletişim taleplerinize yanıt vermek
- Yasal yükümlülüklerimizi yerine getirmek

## 3. Bilgilerin Paylaşımı

Kişisel bilgilerinizi üçüncü taraflarla satmaz, kiralamaz veya başka şekilde paylaşmayız. Sadece:

- Yasal zorunluluk durumlarında
- Hizmet sağlayıcılarımızla (kargo, ödeme işlemleri)
- Açık izniniz olduğunda paylaşım yapabiliriz.

## 4. Veri Güvenliği

Bilgilerinizi korumak için endüstri standardı güvenlik önlemleri uyguluyoruz.

## 5. İletişim

Gizlilik politikamızla ilgili sorularınız için: info@kosad.org
    `
  },
  cerezler: {
    title: 'Çerez Politikası',
    content: `
# Çerez Politikası

Son güncelleme: Ocak 2026

## Çerez Nedir?

Çerezler, web sitelerinin tarayıcınıza yerleştirdiği küçük metin dosyalarıdır. Bu dosyalar, site deneyiminizi iyileştirmek için kullanılır.

## Kullandığımız Çerezler

### Zorunlu Çerezler
- Oturum yönetimi
- Sepet işlemleri
- Güvenlik

### Analitik Çerezler
- Site kullanım istatistikleri
- Performans ölçümü

### İşlevsel Çerezler
- Dil ve tercih ayarları
- Kullanıcı deneyimi iyileştirmeleri

## Çerez Kontrolü

Tarayıcı ayarlarınızdan çerezleri kontrol edebilir veya silebilirsiniz. Ancak bazı çerezleri devre dışı bırakmak, site işlevselliğini etkileyebilir.

## İletişim

Çerez politikamızla ilgili sorularınız için: info@kosad.org
    `
  },
  kullanim: {
    title: 'Kullanım Koşulları',
    content: `
# Kullanım Koşulları

Son güncelleme: Ocak 2026

## 1. Kabul

Bu web sitesini kullanarak aşağıdaki koşulları kabul etmiş sayılırsınız.

## 2. Hizmet Kullanımı

- Sitemizi yasal amaçlarla kullanmalısınız
- Başkalarının haklarına saygı göstermelisiniz
- Zararlı içerik paylaşmamalısınız

## 3. Fikri Mülkiyet

Sitedeki tüm içerik (metinler, görseller, logolar) KOSAD'a aittir veya lisanslıdır. İzinsiz kullanım yasaktır.

## 4. Market Koşulları

- Fiyatlar TL cinsindendir
- Stok durumuna göre değişiklik olabilir
- Siparişler banka havalesi ile ödenir
- İade ve değişim için 14 gün süreniz vardır

## 5. Sorumluluk Sınırlaması

KOSAD, site kullanımından kaynaklanan dolaylı zararlardan sorumlu tutulamaz.

## 6. Değişiklikler

Bu koşulları önceden haber vermeksizin değiştirme hakkımız saklıdır.

## 7. İletişim

Kullanım koşullarıyla ilgili sorularınız için: info@kosad.org
    `
  },
  kvkk: {
    title: 'KVKK Aydınlatma Metni',
    content: `
# KVKK Aydınlatma Metni

Son güncelleme: Ocak 2026

6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla bilgilendirme:

## 1. Veri Sorumlusu

KOSAD - Kocaeli Sürdürülebilir Arıcılık ve Dayanışma Derneği
Adres: Örnek Mahallesi, Doğa Sokak No: 12, Kocaeli
E-posta: info@kosad.org

## 2. İşlenen Kişisel Veriler

- Kimlik bilgileri (ad, soyad)
- İletişim bilgileri (e-posta, telefon, adres)
- Üyelik ve işlem bilgileri

## 3. İşleme Amaçları

- Üyelik işlemlerinin yürütülmesi
- Sipariş ve teslimat işlemleri
- İletişim faaliyetleri
- Yasal yükümlülüklerin yerine getirilmesi

## 4. Hukuki Sebepler

- Sözleşmenin ifası
- Yasal yükümlülük
- Meşru menfaat
- Açık rıza

## 5. Aktarım

Kişisel verileriniz yasal zorunluluklar ve hizmet gereklilikleri dışında üçüncü kişilerle paylaşılmaz.

## 6. Haklarınız (KVKK m.11)

- Kişisel verilerinizin işlenip işlenmediğini öğrenme
- İşlenmişse bilgi talep etme
- Amacına uygun kullanılıp kullanılmadığını öğrenme
- Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme
- Düzeltme talep etme
- Silinmesini veya yok edilmesini isteme
- İtiraz etme
- Zararın giderilmesini talep etme

## 7. Başvuru

Haklarınızı kullanmak için info@kosad.org adresine yazılı başvuru yapabilirsiniz.
    `
  }
};

export const LegalPage = () => {
  const { page } = useParams();
  const content = legalContent[page];

  if (!content) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl text-[#1A3625] mb-4">Sayfa bulunamadı</h2>
          <Link to="/" className="btn-primary">
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="legal-page">
      {/* Breadcrumb */}
      <div className="bg-white py-4 border-b border-[#E5DAC8]">
        <div className="container-custom">
          <Link to="/" className="flex items-center gap-2 text-[#5C5C5C] hover:text-[#1A3625] transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Ana Sayfa
          </Link>
        </div>
      </div>

      <section className="section-padding">
        <div className="container-custom">
          <motion.div
            className="max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-3xl md:text-4xl text-[#1A3625] mb-8">{content.title}</h1>
            
            <div className="prose prose-lg max-w-none">
              {content.content.split('\n').map((line, index) => {
                if (line.startsWith('# ')) {
                  return null; // Skip h1, we already have it
                }
                if (line.startsWith('## ')) {
                  return <h2 key={index} className="text-2xl font-medium text-[#1A3625] mt-8 mb-4">{line.replace('## ', '')}</h2>;
                }
                if (line.startsWith('### ')) {
                  return <h3 key={index} className="text-xl font-medium text-[#1A3625] mt-6 mb-3">{line.replace('### ', '')}</h3>;
                }
                if (line.startsWith('- ')) {
                  return <li key={index} className="text-[#5C5C5C] ml-4 mb-2">{line.replace('- ', '')}</li>;
                }
                if (line.trim() === '') {
                  return <br key={index} />;
                }
                return <p key={index} className="text-[#5C5C5C] mb-4">{line}</p>;
              })}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Other Legal Pages */}
      <section className="py-12 bg-white border-t border-[#E5DAC8]">
        <div className="container-custom">
          <h3 className="text-lg font-medium text-[#1A3625] mb-4">Diğer Yasal Sayfalar</h3>
          <div className="flex flex-wrap gap-4">
            {Object.entries(legalContent).map(([key, value]) => (
              key !== page && (
                <Link
                  key={key}
                  to={`/yasal/${key}`}
                  className="px-4 py-2 bg-[#F9F8F6] rounded-full text-[#5C5C5C] hover:bg-[#E5DAC8] transition-colors"
                >
                  {value.title}
                </Link>
              )
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
